module.exports = "/_next/static/images/b057a4f56f684d5a00d1261d74651a8c-ticket-01-03.png";